export enum InactivityEvents {
  inactiveUser = 'csp-inactive-user',
}

export enum InactivityStorageKeys {
  userSignedOut = 'csp.inactivity.sign.out',
  userActive = 'csp.inactivity.user.active',
  userInactive = 'csp.inactivity.user.inactive',
  userExtendSession = 'csp.inactivity.user.extendSession',
  // Shared timestamp (ms since epoch) of the most recent activity across ALL
  // tabs. This is the source of truth for whole-session inactivity so a single
  // idle tab cannot declare the session inactive while another tab is active.
  userLastActivity = 'csp.inactivity.user.lastActivity',
}

//5 minutes for countdown in modal
export const modalCountdownTimeout = 300000;

//15 minutes as a default for inactivity tracker
export const inactivityDefaultTimeout = 900000;
// 24 hours as a default for web view inactivity tracker
export const WEB_VIEW_INACTIVITY_TIMEOUT = 86400000; // 24 * 60 * 60 * 1000
